// extracted by mini-css-extract-plugin
export default {"success":"Success_success__gtB+J","icon":"Success_icon__Uis1e","info":"Success_info__RK6x5","price":"Success_price__h5ieW","text":"Success_text__eCkUW"};